module.exports = __webpack_public_path__ + "img/blue_099.81016400.png";